import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ChannelsService } from '../../infrastructure/services/channels.service';
import { HomeChannelConfiguracionComponent } from './channel/home.component';
import { TimelineNegocioConfiguracionComponent } from './channel/timeline.component';
import { ChannelDetalle } from 'app/infrastructure/model/classes/configuracionChannel.class';

@Component({
  selector: 'config-channel',
  templateUrl: './channel.component.html',
  providers: [ChannelsService, HomeChannelConfiguracionComponent, TimelineNegocioConfiguracionComponent]
})
export class ChannelComponent implements OnInit {
  channel: ChannelDetalle;
  codSubscription: string;
  codChannel: string;
  seccionActual: String;
  cargandodetalle: Boolean = true;
  constructor(private channelsService: ChannelsService, private aRoute: ActivatedRoute) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      this.seccionActual = params['seccion'];

      const thisComponent = this;
      // this.negociosService
      //   .getNegocioDetalle(this.codSistema || '052', this.codNegocio).then(function (data) {
      //     thisComponent.negocio = data;
      //     thisComponent.cargandodetalle = false;
      //   })
      //   .catch(function () {
      //     thisComponent.cargandodetalle = false;
      //   }); ;
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel.component.ts